import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';

export interface ServiceInfo {
  vcrVersion: string;
  hostname: string;
}

export namespace ServiceInfoAction {
  export class SetVersion {
    static readonly type = '[AppVersion] set app version';

    constructor(public version: string) {
    }
  }
  export class SetHostname {
    static readonly type = '[AppVersion] set hostname';

    constructor(public hostname: string) {
    }
  }
}

@State<ServiceInfo>({
  name: ServiceInfoState.storeName,
  defaults: ServiceInfoState.defaults
})
@Injectable()
export class ServiceInfoState {
  static readonly storeName = 'appInfo';
  static readonly defaults: ServiceInfo = {
    vcrVersion: 'not-fetched',
    hostname: 'not-fetched'
  };

  @Selector()
  static getAppInfo(appInfo: ServiceInfo) {
    return appInfo;
  }

  @Action(ServiceInfoAction.SetVersion)
  setVersion(ctx: StateContext<ServiceInfo>, info: ServiceInfoAction.SetVersion) {
    const state = ctx.getState();

    ctx.patchState({
      ...state,
      vcrVersion: info.version
    });
  }

  @Action(ServiceInfoAction.SetHostname)
  setHostname(ctx: StateContext<ServiceInfo>, info: ServiceInfoAction.SetHostname) {
    const state = ctx.getState();

    ctx.patchState({
      ...state,
      hostname: info.hostname
    });
  }
}
